import * as go from 'gojs';
import { locationBinding, lockedBindings } from '../common/utils/bindings';
import { exclamation, triangle } from './assets/attention.paths';
import { ATTENTION_LAYER_NAME, ATTENTION_SHAPE_NAME } from './config/part-names';

const $ = go.GraphObject.make;
const movable = true;
const resizable = false;
const rotatable = false;

export const attentionNodeTemplate = () =>
  $(
    go.Node,
    go.Node.Spot,
    {
      selectionObjectName: ATTENTION_SHAPE_NAME,
      locationObjectName: ATTENTION_SHAPE_NAME,
      // contextMenu: nodeContextMenu(),
      isLayoutPositioned: false,
      locationSpot: go.Spot.Center,
      toolTip: null,
      copyable: false,
      selectionAdornmentTemplate: attentionAdornment(),
      layerName: ATTENTION_LAYER_NAME,
    },
    $(go.Shape, {
      name: ATTENTION_SHAPE_NAME,
      desiredSize: new go.Size(50, 50),
      geometryString: triangle,
      fill: '#ffcc47',
      stroke: '#2a2a86',
      strokeWidth: 2,
    }),
    $(go.Shape, {
      name: 'exclamation',
      desiredSize: new go.Size(8, 30),
      geometryString: exclamation,
      fill: '#2a2a86',
      stroke: null,
      alignment: new go.Spot(0.5, 0.5, 0, 4),
    }),
    locationBinding(),
    ...lockedBindings({ movable, resizable, rotatable }),
  );

const attentionAdornment = () =>
  $(
    go.Adornment,
    go.Panel.Auto,
    $(go.Shape, {
      fill: null,
      stroke: 'dodgerblue',
      strokeWidth: 4,
      geometryString: triangle,
    }),
    $(go.Placeholder),
  );
